<template>
  <div :class="classes">
      <pt-page-title title="消息列表">
          <el-button slot="before-left" type="primary" @click="publshNotice">发布消息</el-button>
      </pt-page-title>
      <pt-notice-table :tableLabels="nociceTableLabels">
          <el-table-column label="操作">
              <template slot-scope="scope">
                  <el-button type="text" @click="detai(scope.row)">详情</el-button>
              </template>
          </el-table-column>
      </pt-notice-table>
  </div>
</template>

<script>
// 组件class前缀
import { nociceTableLabels } from './notice-option'
import ptNoticeTable from './pt-notice-table/withData'
const prefixCls = 'pt-notice-manage'
export default {
  name: 'pt-notice-manage',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptNoticeTable
  },
  data () {
    return {
      nociceTableLabels: nociceTableLabels
    }
  },
  methods: {
    publshNotice () {
      this.$router.push('/notice-manage/notice-form/false/0')
    },
    detai (val) {
      this.$router.push('/notice-manage/notice-detail/' + val.id)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
